import React from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { getAccounts, Account } from '../services/dataService';

const Accounts: React.FC = () => {
  const accounts = getAccounts();

  return (
    <Box>
      <Typography 
        variant="h4" 
        sx={{ 
          mb: 4,
          color: '#111827',
          fontWeight: 'bold',
          letterSpacing: '-0.025em'
        }}
      >
        Accounts
      </Typography>
      <Paper 
        elevation={0}
        sx={{
          width: '100%',
          overflow: 'hidden',
          border: '1px solid #E5E7EB',
          borderRadius: 2,
        }}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell 
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Account Name
                </TableCell>
                <TableCell 
                  align="right"
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Balance
                </TableCell>
                <TableCell 
                  align="right"
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Currency
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {accounts.map((account: Account) => (
                <TableRow 
                  key={account.id}
                  sx={{
                    '&:hover': {
                      bgcolor: '#F5F6FF',
                    },
                  }}
                >
                  <TableCell 
                    component="th" 
                    scope="row"
                    sx={{
                      color: '#111827',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                    }}
                  >
                    {account.name}
                  </TableCell>
                  <TableCell 
                    align="right"
                    sx={{
                      color: '#111827',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                    }}
                  >
                    ${account.balance.toLocaleString()}
                  </TableCell>
                  <TableCell 
                    align="right"
                    sx={{
                      color: '#111827',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                    }}
                  >
                    {account.currency}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default Accounts; 